// Namespaced keys for frontend session storage.
// Avoids collisions with other applications and enables controlled cleanup.
export const STORAGE_KEYS = {
  token: "wcp.vendor.auth.token",
  role: "wcp.vendor.auth.role",
  principal: "wcp.vendor.auth.principal",
};

